const Constants = {
    USER_LOGGEDIN: 'USER_LOGGEDIN',
    USER_LOGOUT: 'USER_LOGOUT',
}

export default Constants;